import React from 'react';

// Taegukgi (bandera de Corea del Sur) en proporción 3:2.
// El taeguk mide la mitad de la altura y se inclina sobre la diagonal;
// los trigramas (Kye) quedan perpendiculares a las diagonales.
const RED='#CD2E3A';
const BLUE='#0047A0';
const DIAGONAL=Math.atan2(240,360)*180/Math.PI; // 33.69°

// Cada trigrama: 3 barras de arriba a abajo (true = completa, false = partida).
const TRIGRAMS=[
  {name: 'Kum Kye (cielo)',x: 84.3,y: 56.2,rotate: -90+DIAGONAL,bars: [true,true,true]},
  {name: 'Kam Kye (agua)',x: 275.7,y: 56.2,rotate: 90-DIAGONAL,bars: [false,true,false]},
  {name: 'I Kye (fuego)',x: 84.3,y: 183.8,rotate: 90-DIAGONAL,bars: [true,false,true]},
  {name: 'Kon Kye (tierra)',x: 275.7,y: 183.8,rotate: -90+DIAGONAL,bars: [false,false,false]},
];

const BAR={width: 60,height: 10,gap: 5,split: 6};

function Trigram({x,y,rotate,bars,name}) {
  const half=(BAR.width-BAR.split)/2;
  return (
    <g transform={`translate(${x} ${y}) rotate(${rotate})`} aria-label={name}>
      {bars.map((solid,index)=> {
        const top=-20+index*(BAR.height+BAR.gap);
        return solid
          ? <rect key={index} x={-BAR.width/2} y={top} width={BAR.width} height={BAR.height} />
          : (
            <g key={index}>
              <rect x={-BAR.width/2} y={top} width={half} height={BAR.height} />
              <rect x={BAR.split/2} y={top} width={half} height={BAR.height} />
            </g>
          );
      })}
    </g>
  );
}

export default function KoreaFlag({className=''}) {
  return (
    <svg viewBox="0 0 360 240" className={className} role="img" aria-label="Bandera de Corea del Sur (Taegukgi)">
      <rect width="360" height="240" fill="#fff" />
      <g transform={`translate(180 120) rotate(${DIAGONAL})`}>
        <circle r="60" fill={BLUE} />
        {/* Mitad roja (Yang) arriba, con la "cabeza" del lado izquierdo */}
        <path d="M -60 0 A 60 60 0 0 1 60 0 A 30 30 0 0 0 0 0 A 30 30 0 0 1 -60 0 Z" fill={RED} />
      </g>
      <g fill="#000">
        {TRIGRAMS.map(trigram=> <Trigram key={trigram.name} {...trigram} />)}
      </g>
    </svg>
  );
}
